import { combineReducers } from "redux";
import authSlice from "./authSlice";
import allPreLoadedApis from "./preloadedApisSlice";
import pageSlice from "./pageSlice";
import bookingFilterSlice from "./bookingFilterSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  allPreLoadedApis,
  page: pageSlice,
  bookingFilter: bookingFilterSlice,
});

export default rootReducer;
